module.exports = __webpack_public_path__ + "static/media/ic-landing-company.f727ba89.png";